const colors = {
  lightGrey: '#E0E0E0',
  lightGrey2: '#EAEAEA',
  commonLightGrey: '#F1F1F1',
  commonGrey: '#F3F3F3',
  grey: '#F4F4F4',
  darkGray: '#D9D9D9',
  darkGray2: '#CCCCCC',
  darkGray3: '#424242',
  darkerGray: '#C0C0C0',
  backgroundGrey: '#DEDEDE',
  headerBg: '#ECECEC',
  primary: '#0B7CB7',
  primaryLight: '#ADCCE9',
  primaryDark: '#1B8FCB',
  darkBlue: '#000056',
  lightBlue: '#D8EDF1',
  secondaryLight: '#48B2E9',
  green: '#58E5A2',
  lightGreen: '#29AE6F',
  pink: '#E22758',
  orange: '#FF8A00',
  black: '#000000',
  white: '#FFFFFF',
  bodyText: '#353535',
  inputBorder: 'rgba(0, 0, 0, 0.23)',
  disabledFormControlText: '#BDBDBD',
  error: 'rgb(211, 47, 47)',
  activeAreaBorder: '#C9C9C9',
  messages: {
    canceled: {
      border: '#acb4c3',
      background: '#f7f7f9',
    },
    accepted: {
      border: '#6da625',
      background: '#f0f6e9',
    },
    reactivate: {
      border: '#57a7d6',
      background: '#e7f3fa',
    },
    rescheduling: {
      border: '#2f9e44',
      background: '#e0f1e3',
    },
    missingAvailability: {
      border: '#de3350',
      background: '#fbeaed',
    },
  },
}

const componentSizes = {
  headerMinHeight: '70px',
  leftNavWidth: '60px',

  maxContentSectionWidth: '1224px',
  otherInfoSectionWidth: '250px',
  profileRightColumnWidth: '285px',
  xsDistance: '12px',
  smDistance: '16px',
  mdDistance: '20px',
  lgDistance: '26px',
}

const dateTimeFormats = {
  eventDateFormat: 'MMM dd, yyyy',
}

export { colors, componentSizes, dateTimeFormats }
